import axiosInstance from "app/axiosInstance";

class WhiteLabels {
  static getWhiteLabelConfiguration = async (id: string) => {
    return await axiosInstance.get(`/whitelabels/${id}`);
  };
}

export default WhiteLabels;
